import { Route, Routes } from "react-router-dom";
import TransferRequestsStatus from "../../ContainersManager/TransferRequestsStatus";
import ContainerTasks from "../../ContainersManager/ContainerTasks";
import InitialScreeningEvaluation from "../../ContainersManager/InitialScreeningEvaluation";
import EvaluationInformation from "../../ContainersManager/EvaluationInformation";
import SetEvaluterForm from "../../Pages/Manager/SetEvaluter/setEvaluterForm";
import SetEvaluter from "../../Pages/Manager/SetEvaluter";
import TransferBetweenEvaluators from "../../ContainersManager/TransferBetweenEvaluators";
import SummaryInfo from "../../Pages/Manager/SummaryInfo";
import ScientificCommittee from "../../ContainersManager/ScientificCommittee";
import SummaryInformation from "../../ContainersManager/SummaryInformation";
import RequestsEvaluation from "../../Pages/Manager/RequestsEvaluation";
import MainResearcherInformainContainer from "../../Containers/MainResearcherInformainContainer";
import ResearchProposalInformation from "../../Containers/ResearchProposalInformation";
import WorkPlanEstimatedBudget from "../../Containers/WorkPlanEstimatedBudget";
import ConflictOfInterestAndResearchEthics from "../../Containers/ConflictOfInterestAndResearchEthics";
import AttachmentsContainer from "../../Containers/AttachmentsContainer";
import AllApplicationRequest from "../../Pages/Manager/AllApplicationRequest";
import AllTasks from "../../Pages/Manager/AllTasks";
import ReportStageRequest from "../../ContainersReport/ReportStage/ReportStageRequest";

import ActivitiesTable from "../../Pages/Report/ActivitiesTable";

import AppInfo from "../../Pages/Report/AppInfo";
import AboutProject from "../../Pages/Report/AboutProject";
import SubObjectives from "../../Pages/Report/SubObjectives";
import ProgressReportPreparation from "../../ContainersReport/ProgressReportPreparation";
import StagesTable from "../../Pages/Report/StagesTable";
import StagesTableContainers from "../../ContainersReport/StagesTableContainers";
import AddStagesContainers from "../../ContainersReport/AddStagesContainers";
import ReportStageForm from "../../ContainersReport/ReportStageForm";
import EmployeeTransfers from "../../ContainersReport/EmployeeTransfers";
import RequestsModifyProject from "../../Pages/Report/ProjectModificationRequests/TransferRequestDetails";
import TransferRequestDetails from "../../Pages/Report/ProjectModificationRequests/TransferRequestDetails";
import ProjectExtensionRequestDetails from "../../Pages/Report/ProjectModificationRequests/ProjectExtensionRequestDetails";
import ReportStage from "../../Pages/Submitter/ReportStage";

const MainRoutsManager = () => {
  return (
    <>
      <Routes>
        <Route
          path="/SRFund/manager/TransferRequestsStatus/"
          element={<TransferRequestsStatus />}
        />
        <Route
          path="/SRFund/manager/subobjective/"
          element={<SubObjectives />}
        />
        <Route
          path="/SRFund/report/ReportStageRequest/"
          element={<ReportStageRequest />}
        />
        <Route
          path="/SRFund/report/AddStagesContainers/:reportId"
          element={<AddStagesContainers />}
        />

        <Route
          path="/SRFund/report/StagesTable/:reportId"
          element={<StagesTableContainers />}
        />

        <Route
          path="/SRFund/report/ProgressReportPreparation/:reportId"
          element={<ProgressReportPreparation />}
        />
        <Route
          path="/SRFund/report/EmployeeTransfers/:reportId"
          element={<EmployeeTransfers />}
        />
        <Route
          path="/SRFund/manager/report/EmployeeTransfers/:reportId"
          element={<EmployeeTransfers />}
        />
        <Route
          path="/SRFund/report/TransferRequestDetails/:reportId/:projectModificationRequestsId"
          element={<TransferRequestDetails />}
        />

        <Route
          path="/SRFund/report/ProjectExtensionRequestDetails/:reportId/:projectModificationRequestsId"
          element={<ProjectExtensionRequestDetails />}
        />

        <Route
          path="/SRFund/report/ReportStageForm/:reportId/:reportStageId"
          element={<ReportStageForm />}
        />

        <Route path="/SRFund/report/info/" element={<AppInfo />} />
        <Route path="/SRFund/report/infoo/" element={<AboutProject />} />
        <Route
          path="/SRFund/manager/ScientificCommittee/"
          element={<ScientificCommittee />}
        />
        <Route
          path="/SRFund/manager/ContainerTasks/:flowGUID/:actionGuid/:RoundId/:FieldId"
          element={<ContainerTasks />}
        />
        <Route
          path="/SRFund/manager/InitialScreeningEvaluation/:taskId"
          element={<InitialScreeningEvaluation />}
        />
        <Route
          path="/SRFund/manager/SummaryInformation/:taskId"
          element={<SummaryInformation />}
        />
        <Route
          path="/SRFund/manager/EvaluationInformation/:subTaskId"
          element={<EvaluationInformation />}
        />
        <Route
          path="/SRFund/manager/RequestsEvaluation/"
          element={<RequestsEvaluation />}
        />
        <Route
          path="/SRFund/manager/SetEvaluterForm/:userId"
          element={<SetEvaluterForm />}
        />
        <Route path="/SRFund/manager/SetEvaluter/" element={<SetEvaluter />} />
        <Route
          path="/SRFund/manager/EvaluatorTransfer/"
          element={<TransferBetweenEvaluators />}
        />
        <Route
          path="/SRFund/manager/AllApplicationRequest/"
          element={<AllApplicationRequest />}
        />
        <Route
          path="/SRFund/manager/AllTasks/:applicationGuid"
          element={<AllTasks />}
        />
        {/* ///////////////////////////////view application//////////////////////////////////////////// */}
        <Route
          path="/SRFund/manager/MainResearcherInformainContainer/:aI_ApplicationInformationId"
          element={<MainResearcherInformainContainer />}
        />
        <Route
          path="/SRFund/manager/ResearchProposalInformation/:aI_ApplicationInformationId"
          element={<ResearchProposalInformation />}
        />
        <Route
          path="/SRFund/manager/WorkPlanEstimatedBudget/:aI_ApplicationInformationId"
          element={<WorkPlanEstimatedBudget />}
        />
        <Route
          path="/SRFund/manager/ConflictOfInterestAndResearchEthics/:aI_ApplicationInformationId"
          element={<ConflictOfInterestAndResearchEthics />}
        />
        <Route
          path="/SRFund/manager/AttachmentsAndPledge/:aI_ApplicationInformationId"
          element={<AttachmentsContainer />}
        />

        <Route path="/SRFund/manager/ReportStage/:aI_ApplicationInformationId" element={<ReportStage />} />
        {/* <Route
          path="/SRFund/manager/ReportStageRequest/:aI_ApplicationInformationId"
          element={<ReportStageRequest />}
        /> */}

        {/* ///////////////////////////////view application//////////////////////////////////////////// */}

        <Route path="/SRFund/manager/Summary/" element={<SummaryInfo />} />

        <Route
          path="/SRFund/report/ActivitiesTable/"
          element={<ActivitiesTable />}
        />
      </Routes>
    </>
  );
};

export default MainRoutsManager;
